
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/Dialoger/Dialoger.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./Dialoger.html');
        
        var script = require('./Dialoger.ts').default;
        module.exports = require('./Dialoger.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    